import { useTranslation } from "react-i18next";
import { Streams as StreamsFeature } from "@/partner/features/streams";
import { Meta } from "@/shared/components";

export function StreamsPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("streams.pageTitle")} pageType="Partner" />
      <StreamsFeature />
    </>
  );
}
